import { render } from "./AuthorDetails.vue?vue&type=template&id=17e2db39&scoped=true"
import script from "./AuthorDetails.vue?vue&type=script&lang=js"
export * from "./AuthorDetails.vue?vue&type=script&lang=js"

import "./AuthorDetails.vue?vue&type=style&index=0&id=17e2db39&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e2db39"]])

export default __exports__